import { Layout, Skeleton, Typography } from "antd";
import React, { useRef } from "react";
import {
  initPrincipalSlice,
  setPropertiesPrincipal,
  updatePrincipal,
} from "../Slices/Principal.slice";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import routes from "../../../engine/routes";
import { principalsDetailinputs } from "./PrincipalDetailForm";

const { Content, Sider, Header, Footer } = Layout;

export function PrincipalDetail({ unitId, expanded, onClose }) {
  const { id } = useParams();

  const { principal, loading } = useSelector(state => state.principal);

  const { init, clear } = initPrincipalSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const inputs = principalsDetailinputs(principal);

  const onSubmitForm = async data => {
    await dispatch(setPropertiesPrincipal(data));
    dispatch(updatePrincipal());
  };

  return (
    <>
      <Typography.Title level={3} className={""}>
        {routes.principals(id).detail.title}
      </Typography.Title>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <CustomForm
            rule={routes.principals(id).detail}
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />
        </>
      )}
    </>
  );
}
